import { Handshake, HandCoins } from "lucide-react";

export default function ProfileTypeBadge({ type, size = "sm" }) {
  if (!type) return null;
  const isAvailable = type === "AVAILABLE_FOR_RENTAL";
  const isLooking = type === "LOOKING_TO_RENT";
  if (!isAvailable && !isLooking) return null;
  const dims = size === "lg" ? "text-xs px-2.5 py-1" : "text-[10px] px-2 py-0.5";
  const Icon = isAvailable ? Handshake : HandCoins;
  const cls = isAvailable
    ? "bg-emerald-50 text-emerald-700 border-emerald-200"
    : "bg-indigo-50 text-indigo-700 border-indigo-200";
  return (
    <span
      data-testid={`profile-type-badge-${type}`}
      className={`inline-flex items-center gap-1 rounded-full border font-semibold ${cls} ${dims}`}
    >
      <Icon className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} />
      {isAvailable ? "Available for Rental" : "Looking to Rent"}
    </span>
  );
}
